'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const PageDataAttributes = () => {
    const pathname = usePathname();

    useEffect(() => {
        document.body.setAttribute('data-page', pathname || '');
    }, [pathname]);

    return null;
};

export { PageDataAttributes };
